import { fromLocalDatetimeInput, toLocalDatetimeInput } from "./utils";

const warsaw = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Europe/Warsaw",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hourCycle: "h23",
});

function parts(date: Date) {
  return Object.fromEntries(warsaw.formatToParts(date).map(({ type, value }) => [type, value]));
}

function calendarDay(value: string): number {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) throw new Error("Podaj poprawną datę.");
  const time = Date.parse(`${value}T00:00:00.000Z`);
  if (!Number.isFinite(time) || new Date(time).toISOString().slice(0, 10) !== value)
    throw new Error("Podaj poprawną datę.");
  return time;
}

// Resolve Warsaw midnight without depending on the browser's timezone.
function midnight(day: number): number {
  let instant = day;
  for (let i = 0; i < 3; i++) {
    const p = parts(new Date(instant));
    const represented = Date.parse(
      `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}:${p.second}Z`,
    );
    instant += day - represented;
  }
  return instant;
}

export function eventDateInput(iso: string | null | undefined, isAllDay: boolean): string {
  if (!iso) return "";
  if (!isAllDay) return toLocalDatetimeInput(iso);
  try {
    if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
      calendarDay(iso);
      return iso;
    }
    const p = parts(new Date(iso));
    return `${p.year}-${p.month}-${p.day}`;
  } catch {
    return "";
  }
}

export function eventFormDates(form: { date: string; endDate: string; isAllDay: boolean }): {
  date: string | null;
  endDate: string | null;
} {
  const convert = (value: string, end: boolean) => {
    if (!value) return null;
    if (form.isAllDay) {
      const day = calendarDay(value);
      return new Date(end ? midnight(day + 86400000) - 1 : midnight(day)).toISOString();
    }
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?$/.test(value))
      throw new Error("Podaj datę i godzinę.");
    calendarDay(value.slice(0, 10));
    const result = fromLocalDatetimeInput(value);
    if (!result) throw new Error("Podaj poprawną datę i godzinę.");
    return result;
  };
  const date = convert(form.date, false);
  const endDate = convert(form.endDate, true);
  if (date && endDate && Date.parse(endDate) < Date.parse(date))
    throw new Error("Data zakończenia nie może być wcześniejsza niż data rozpoczęcia.");
  return { date, endDate };
}
